export default __webpack_public_path__ + "static/media/ic_basque_country.585c458c.svg";